import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../contexts/auth/Context";
import { getPlanCategoriesRequest } from "../../../hooks/requests/plan";
import { PLAN_CATEGORIES_QUERY_KEY } from "../../../query/keys";
import { CACHE_TIMES } from "../../../query/options";
import { LoadingSpinner } from "../../common/loadingSpinner";

export const GymPlanCategories = () => {
  const { token } = useAuth();

  const { data: categories, isLoading } = useQuery({
    queryKey: PLAN_CATEGORIES_QUERY_KEY,
    queryFn: () => getPlanCategoriesRequest(token!),
    enabled: !!token,
    ...CACHE_TIMES.STATIC_DATA,
  });

  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <LoadingSpinner />
      </div>
    );
  }

  if (!categories || categories.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-10 gap-2 text-center">
        <div className="w-10 h-10 rounded-full bg-global-overlay-secondary flex items-center justify-center">
          <svg
            className="w-5 h-5 text-global-muted"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
            />
          </svg>
        </div>
        <p className="text-size-sm text-global-muted">
          No hay categorías de plan configuradas
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {categories.map((cat) => (
        <div
          key={cat.publicId}
          className="card-section flex items-center gap-3"
        >
          <div className="w-8 h-8 rounded-lg bg-global-overlay-secondary border border-global-secondary flex items-center justify-center shrink-0">
            <svg
              className="w-4 h-4 text-global-secondary"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
              />
            </svg>
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-size-sm font-semibold text-global-primary truncate">
              {cat.name}
            </p>
            <code className="text-size-2xs font-mono text-global-muted">
              {cat.key}
            </code>
          </div>

          <span
            className={`inline-flex items-center px-2 py-0.5 rounded-full text-size-2xs font-medium border shrink-0 ${
              cat.isClassBased
                ? "bg-global-accent-overlay text-global-accent border-global-secondary"
                : "bg-global-overlay-secondary text-global-muted border-global-secondary"
            }`}
          >
            {cat.isClassBased ? "Clases" : "Membresía"}
          </span>
        </div>
      ))}
    </div>
  );
};
